import { InventoryStateTransitionResponseSchema, MarkShippedRequestSchema, RegenerateClaimCodeRequestSchema, RegenerateClaimCodeResponseSchema, RetireDeviceRequestSchema, ReturnDeviceRequestSchema, } from '../../schemas.js';
import { OpsAllocateDeviceRequestSchema, OpsAllocateDeviceResponseSchema, OpsAllowReprovisionRequestSchema, OpsAllowReprovisionResponseSchema, OpsAuditLogResponseSchema, OpsBulkAllocateRequestSchema, OpsBulkAllocateResponseSchema, OpsDeviceDetailResponseSchema, OpsDeviceListQuerySchema, OpsDeviceListResponseSchema, OpsFleetStatsResponseSchema, OpsIotRevokeCertificateRequestSchema, OpsIotRevokeCertificateResponseSchema, OpsProviderActivateResponseSchema, OpsRebootDeviceRequestSchema, OpsRebootDeviceResponseSchema, OpsRegisterDeviceResponseSchema, OpsRegisterIotDeviceRequestSchema, OpsRegisterNonIotDeviceRequestSchema, OpsResetDeviceResponseSchema, OpsRevealBreakGlassPasswordRequestSchema, OpsRevealBreakGlassPasswordResponseSchema, OpsSerialNumberParamSchema, OpsTriggerReprovisionRequestSchema, OpsTriggerReprovisionResponseSchema, OpsUnallocateDeviceRequestSchema, OpsUnallocateDeviceResponseSchema, OpsUpdateNonIotDeviceBodySchema, OpsUpdateNonIotDeviceResponseSchema, } from '../../schemas/ops-devices.schemas.js';
/** REST contract for `insight-api/src/routes/provider/ops-devices.routes.ts`. */
export const opsDevicesContract = {
    getFleetStats: {
        method: 'GET',
        path: '/provider/ops/devices/stats',
        response: OpsFleetStatsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get fleet stats',
    },
    list: {
        method: 'GET',
        path: '/provider/ops/devices',
        query: OpsDeviceListQuerySchema,
        response: OpsDeviceListResponseSchema,
        responseStyle: 'parse-response',
        queryLimitMax: 200,
        errorMessage: 'Failed to list devices',
    },
    getBySerial: {
        method: 'GET',
        path: '/provider/ops/devices/:serialNumber',
        pathParams: OpsSerialNumberParamSchema,
        response: OpsDeviceDetailResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get device',
    },
    getAuditLog: {
        method: 'GET',
        path: '/provider/ops/devices/:serialNumber/audit-log',
        pathParams: OpsSerialNumberParamSchema,
        response: OpsAuditLogResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get device audit log',
    },
    allocate: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/allocate',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsAllocateDeviceRequestSchema,
        response: OpsAllocateDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to allocate device',
    },
    unallocate: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/unallocate',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsUnallocateDeviceRequestSchema,
        response: OpsUnallocateDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to unallocate device',
    },
    revokeCertificate: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/revoke-certificate',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsIotRevokeCertificateRequestSchema,
        response: OpsIotRevokeCertificateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to revoke device certificate',
    },
    reset: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/reset',
        pathParams: OpsSerialNumberParamSchema,
        response: OpsResetDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to reset device',
    },
    bulkAllocate: {
        method: 'POST',
        path: '/provider/ops/devices/bulk-allocate',
        body: OpsBulkAllocateRequestSchema,
        response: OpsBulkAllocateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to bulk allocate devices',
    },
    markShipped: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/mark-shipped',
        pathParams: OpsSerialNumberParamSchema,
        body: MarkShippedRequestSchema,
        response: InventoryStateTransitionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to mark device shipped',
    },
    returnDevice: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/return',
        pathParams: OpsSerialNumberParamSchema,
        body: ReturnDeviceRequestSchema,
        response: InventoryStateTransitionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to return device',
    },
    retireDevice: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/retire',
        pathParams: OpsSerialNumberParamSchema,
        body: RetireDeviceRequestSchema,
        response: InventoryStateTransitionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to retire device',
    },
    regenerateClaimCode: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/regenerate-claim-code',
        pathParams: OpsSerialNumberParamSchema,
        body: RegenerateClaimCodeRequestSchema,
        response: RegenerateClaimCodeResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to regenerate claim code',
    },
    allowReprovisioning: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/allow-reprovisioning',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsAllowReprovisionRequestSchema,
        response: OpsAllowReprovisionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to allow device re-provisioning',
    },
    triggerReprovisioning: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/trigger-reprovisioning',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsTriggerReprovisionRequestSchema,
        response: OpsTriggerReprovisionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to trigger device re-provisioning',
    },
    reboot: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/reboot',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsRebootDeviceRequestSchema,
        response: OpsRebootDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to reboot device',
    },
    revealBreakGlassPassword: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/reveal-break-glass-password',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsRevealBreakGlassPasswordRequestSchema,
        response: OpsRevealBreakGlassPasswordResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to reveal break-glass password',
    },
    registerIotDevice: {
        method: 'POST',
        path: '/provider/ops/devices/iot-devices',
        body: OpsRegisterIotDeviceRequestSchema,
        response: OpsRegisterDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to register IoT device',
    },
    registerNonIotDevice: {
        method: 'POST',
        path: '/provider/ops/devices/non-iot-devices',
        body: OpsRegisterNonIotDeviceRequestSchema,
        response: OpsRegisterDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to register non-IoT device',
    },
    providerActivate: {
        method: 'POST',
        path: '/provider/ops/devices/:serialNumber/provider-activate',
        pathParams: OpsSerialNumberParamSchema,
        response: OpsProviderActivateResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to provider-activate device',
    },
    updateNonIotDevice: {
        method: 'PATCH',
        path: '/provider/ops/devices/:serialNumber',
        pathParams: OpsSerialNumberParamSchema,
        body: OpsUpdateNonIotDeviceBodySchema,
        response: OpsUpdateNonIotDeviceResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update non-IoT device',
    },
};
//# sourceMappingURL=ops-devices.contract.js.map